export const mergeOpacity = (fg_color: any, bg_color: any) => {
  const r = Math.round(bg_color.red() + (fg_color.red() - bg_color.red()) * fg_color.alpha());
  const g = Math.round(bg_color.green() + (fg_color.green() - bg_color.green()) * fg_color.alpha());
  const b = Math.round(bg_color.blue() + (fg_color.blue() - bg_color.blue()) * fg_color.alpha());

  return `rgb(${r}, ${g}, ${b})`;
};
